import { TYPE_NATCOM_AIRTIME, TYPE_NATCOM_DIGICEL_VMAIL, TYPE_NATCOM_NTM, TYPE_NATCOM_VMAIL_AIRTIME } from "./type";

const initialState = {
  data: {},
};

export const reducerNatcom = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_NATCOM_VMAIL_AIRTIME:
      return {
        ...state,
        data: action.payload,
      };
    case TYPE_NATCOM_DIGICEL_VMAIL: 
      return {
        ...state,
        data: action.payload,
      };
    case TYPE_NATCOM_NTM: 
      return {
        ...state,
        data: action.payload,
      };
    case TYPE_NATCOM_AIRTIME: 
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};
